import { BlogArticleVisitPluginProps, BlogArticleVisitPluginStateProps } from '../../types/components/user-interest-analytics/BlogArticleVisitPlugin';
import { User } from '../../types/api/UsersTypes';

import { ApplicationState } from '../../types/state/storeTypes';

import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import userInterestAnalyticsHelpers from '../../helpers/analytics/userInterestAnalytics';

import { ENV } from '../../constants/environments';

const BlogArticleVisitPlugin: React.FC<BlogArticleVisitPluginProps> = (props: BlogArticleVisitPluginProps) => {
  if (ENV.appEnv !== 'production' && typeof window !== "undefined" && !window?.Cypress) return <></>;

  const { user, article, authenticated } = props;
  const [visitReported, setVisitReported] = useState<boolean>(false);
  const { createBlogArticleVisitEvent, touchCookie } = userInterestAnalyticsHelpers;

  useEffect(() => {
    touchCookie();
  }, []);

  const reportArticleVisit = async () => {
    try {
      await createBlogArticleVisitEvent(article, user);
      setVisitReported(true);
    } catch {};
  }

  useEffect(() => {
    if (authenticated !== true && authenticated !== false || !!visitReported) return;
    reportArticleVisit();
  }, [authenticated]);

  return <></>;
};

const mapStateToProps = (state: ApplicationState): BlogArticleVisitPluginStateProps => ({
  user: state.auth.user as User,
  authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps)(BlogArticleVisitPlugin);
